import React, { cloneElement, type ReactElement } from 'react';
import { ControlGroup } from '../../ControlGroup';
import type {
    RadioControlGroupOptionProps,
    RadioControlGroupValue,
} from '../RadioControlGroupOption';
import { StyledNestedControl, type StyledNestedControlProps } from '../styles';

interface NestedControlProps
    extends StyledNestedControlProps,
        Omit<RadioControlGroupOptionProps, 'children'> {
    selectedValue: RadioControlGroupValue;
    disabled?: boolean;
    child: ReactElement;
}

export const NestedControl = ({
    $row,
    selectedValue,
    disabled,
    value,
    label,
    error,
    child,
}: NestedControlProps) => {
    const isSelected = selectedValue === value;
    const nestedInputProps = {
        disabled: disabled || !isSelected,
        ...(isSelected && { error: !!error }),
    };

    return (
        <StyledNestedControl $row={$row}>
            <ControlGroup
                label={label}
                hideLabel
                controlsLayout="fill"
                help={isSelected ? child.props.help : undefined}
                error={isSelected ? error : undefined}
            >
                {cloneElement(child, nestedInputProps)}
            </ControlGroup>
        </StyledNestedControl>
    );
};
